"use strict";

/* ------------------------------------------------------------------ *
 * Mapper 32: Irem G-101 (Image Fight)
 * ------------------------------------------------------------------ */
function register(Mappers) {
  Mappers[32] = function (nes) {
    this.nes = nes;
  };
  Mappers[32].prototype = new Mappers[0]();
  Mappers[32].prototype.irqClockRate = "none";

  Mappers[32].prototype.reset = function () {
    Mappers[0].prototype.reset.apply(this);
    this.prgBank = 0;
  };

  Mappers[32].prototype.write = function (address, value) {
    if (address >= 0x8000) {
      this.prgBank = value & 0x0f;
      this.loadRomBank(this.prgBank, 0x8000);
    } else {
      Mappers[0].prototype.write.apply(this, arguments);
    }
  };

  Mappers[32].prototype.loadROM = function () {
    if (!this.nes.rom.valid) {
      throw new Error("Irem G-101: Invalid ROM! Unable to load.");
    }
    this.reset();
    this.loadCHRROM();
    this.loadBatteryRam();
    this.loadTrainer();
    this.loadRomBank(0, 0x8000);
    this.loadRomBank(this.nes.rom.romCount - 1, 0xc000);
    this.nes.cpu.requestIrq(this.nes.cpu.IRQ_RESET);
  };
}

module.exports = { register: register };
